import { useState } from 'react';
import { Star0 } from '@unified-checkout/design-system/icons/stars';
import type { IRatingProps } from '../../types/rating';
import styles from './rating.module.scss';

const Rating = ({
  maxStars = 5,
  initialRating = 0,
  onRatingChange,
}: IRatingProps) => {
  const [rating, setRating] = useState<number>(initialRating);
  const [hoveredRating, setHoveredRating] = useState<number>(0);

  const handleStarClick = (rating: number) => {
    setRating(rating);
    onRatingChange?.(rating);
  };

  const handleStarHover = (rating: number) => {
    setHoveredRating(rating);
  };

  const handleMouseLeave = () => {
    setHoveredRating(0);
  };

  return (
    <div
      className={styles["rating"]}
      onMouseLeave={handleMouseLeave}
    >
      {Array.from({ length: maxStars }, (_, index) => {
        const starIndex = index + 1;
        const isHovered = hoveredRating >= starIndex;
        const isSelected = (starIndex <= rating) && !hoveredRating;

        return (
          <div
            key={`rating-star-${starIndex}`}
            className={styles["rating-star"]}
            data-star-hovered={isHovered}
            data-star-selected={isSelected}
            onClick={() => handleStarClick(starIndex)}
            onMouseEnter={() => handleStarHover(starIndex)}
          >
            {Star0}
          </div>
        )
      })}
    </div>
  )
}

export default Rating;